import ERC20_ABI from "../abi/ERC20.json";
import useContract from "./useContract";

export default function useERC20Contract(tokenAddress: string) {
  return useContract(tokenAddress, ERC20_ABI.abi);
}
